import { render } from "./TicketRespons.vue?vue&type=template&id=9a0804d2&scoped=true"
import script from "./TicketRespons.vue?vue&type=script&lang=js"
export * from "./TicketRespons.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9a0804d2"

export default script